import { motion, AnimatePresence } from "framer-motion";
import { FC, useState, useRef } from "react";
import styles from "./MagicAiIcon.module.scss";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "@shared/constants";
import { getHipticFeedback } from "@shared/utils";
import { AiIcon } from "./AiIcon";

export const MagicAIIcon: FC = () => {
  const navigate = useNavigate();
  const [isButtonClicked, setIsButtonClicked] = useState<boolean>(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const handleAIButtonClick = () => {
    ym(104272047, "reachGoal", "btn-ai-search-click-footer");
    setIsButtonClicked(true);
    getHipticFeedback("medium");
    if (intervalRef.current) clearInterval(intervalRef.current);

    setTimeout(() => {
      setIsButtonClicked(false);
      navigate(AppRoutes.ROOT + AppRoutes.MATCH_SECOND_VERSION);
    }, 1000);
  };

  return (
    <motion.div
      className={styles.aiMatches}
      whileHover={{
        scale: 1.05,
        boxShadow: [
          "0 0 15px rgba(120, 82, 238, 0.7), 0 0 25px rgba(120, 82, 238, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.5)",
        ],
      }}
      whileTap={{ scale: 0.98 }}
      onClick={handleAIButtonClick}
    >
      <motion.div
        className={styles.aiMatchesIcon}
        animate={
          isButtonClicked
            ? {
                scale: [1, 1.4, 1],
                transition: { duration: 0.7, times: [0, 0.3, 1] },
              }
            : {}
        }
      >
        <div className={styles.magicIconWrapper}>
          <AiIcon />
        </div>
      </motion.div>

      <AnimatePresence>
        {isButtonClicked && (
          <>
            <motion.div
              className={styles.clickExplosion}
              initial={{ width: 0, height: 0, opacity: 0.7 }}
              animate={{ width: "100vw", height: "100vh", opacity: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1.2 }}
            />
            <motion.div
              className={styles.clickShockwave}
              initial={{ width: 0, height: 0, opacity: 0.9 }}
              animate={{ width: "100vw", height: "100vh", opacity: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1, delay: 0.1 }}
            />
          </>
        )}
      </AnimatePresence>
    </motion.div>
  );
};
